/** @format */

import {useState} from 'react';

import {Box, IconButton, Typography} from '@mui/material';

import {Trans} from 'react-i18next';

import {toggleArrayValue} from 'helpers/arrayHelpers';

import {WidgetBlock} from 'pages/Home/DigitalCast/models/widgets';

import {Space} from 'pages/Home/DigitalCast/models/spaces';

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';

import {WIDGETS_LIST} from 'pages/Home/DigitalCast/constants/widgets';

import {ButtonsBox} from '../../style';
import CheckboxRow from '../checkbox-row';
import DropdownButton from '../dropdown-button';
import {SubMenuRoot as Root, subMenuClasses as classes} from './style';

interface Props {
  data?: WidgetBlock;
  top: string;
  onClose: () => void;
  space: Space;
  onConfirm: (selected: ChartIds[]) => void;
}

const SubMenu = ({top, onClose, data, space, onConfirm}: Props) => {
  const [selected, setSelected] = useState<ChartIds[]>(space.widgetsMenuSelected);

  const backImg = new URL('../../images/back.svg', import.meta.url).href;
  const open = Boolean(data);

  const handleChangeSelection = (id: ChartIds) => {
    setSelected(prev => toggleArrayValue(prev, id));
  };

  const handleConfirm = () => {
    onConfirm(selected);
  };

  const handleCancel = () => {
    setSelected(space.widgetsMenuSelected);
    onClose();
  };

  return (
    <Root openSubMenu={open} top={top}>
      {open && <Box className={classes.contentLock} />}
      <Box className={classes.subMenu}>
        <Box>
          <Box className={classes.headerBox}>
            <IconButton className={classes.headerBackButton} onClick={onClose}>
              <img src={backImg} alt='<-' />
            </IconButton>
            <Box className={classes.headerTitleBox}>
              <Typography className={classes.regularText}>{data?.label}</Typography>
            </Box>
          </Box>

          <Box className={classes.descriptionBox}>
            <Typography className={classes.regularText}>
              <Trans>Выберите показатели, которые следует отображать в меню</Trans>
            </Typography>
          </Box>
        </Box>

        <Box className={classes.scrollable}>
          {(data?.subMenu?.widgets || []).map(id => (
            <CheckboxRow
              key={id}
              checked={selected.includes(id)}
              onChange={() => handleChangeSelection(id)}
              label={
                String(id).startsWith('funnel_cr_')
                  ? space.widgetsSettings[id]?.custom?.label || WIDGETS_LIST[id].label
                  : WIDGETS_LIST[id].label
              }
            />
          ))}
        </Box>

        <ButtonsBox>
          <DropdownButton variant='primary' onClick={handleConfirm}>
            Применить
          </DropdownButton>
          <DropdownButton variant='secondary' onClick={handleCancel}>
            Отмена
          </DropdownButton>
        </ButtonsBox>
      </Box>
    </Root>
  );
};

export default SubMenu;
